const Sidebar = ({ board, dataUser }) => {
    const cambio = (text) => {
        board(text);
    };

    if (!dataUser) {
        // Renderiza un estado inicial mientras dataUser se carga
        return <div className="sidebar">Cargando...</div>;
    }

    return (
        <div className="sidebar">
            <a href="#1" onClick={() => cambio('index')}>Inicio</a>
            <a href="#1" onClick={() => cambio('Cargar')}>Cargar Saldo</a>

            {dataUser.typeUser === 'activo' && !dataUser.vendedor && (
                <a href="#1" onClick={() => cambio('ActivarVendedor')}>Activar Vendedor</a>
            )}
            {dataUser.vendedor && (
                <a href="#1" onClick={() => cambio('ActivarVendedor')}>Vendedor</a>
            )}
        </div>
    );
};

export default Sidebar;
